import Component from 'gia/Component'

export default class ComponentPageHeader extends Component {
  constructor(element) {
    super(element)

    this.options = {
      delay: 0.3,
    }
  }

  mount() {
    let newContent = '<h1>'
    this.element.innerText.split(' ').forEach(
      function(word, index) {
        newContent += `<span><span style="animation-delay: ${index *
          this.options.delay +
          0.4}s">${word}</span></span> `
      }.bind(this)
    )
    newContent += '</h1>'
    this.element.innerHTML = newContent
  }
}



// WEBPACK FOOTER //
// ./scripts/components/PageHeader.js